const { applyMiddleware, createStore } = require("redux");
const createSagaMiddleware = require("redux-saga").default;
const { createLogger } = require("redux-logger");
const { composeWithDevTools } = require("redux-devtools-extension");
const rootSaga = require("./sagas").default;
const reducers = require("./reducers").default;

function configureStore(initialState) {
  try {
    const sagaMiddleware = createSagaMiddleware();
    const middlewares = [sagaMiddleware];

    // Only add logger middleware in development
    if (process.env.NODE_ENV === "development") {
      const logger = createLogger({
        collapsed: true,
        diff: true,
      });
      middlewares.push(logger);
    }

    const store = createStore(reducers, initialState, composeWithDevTools(applyMiddleware(...middlewares)));

    sagaMiddleware.run(rootSaga);

    if (module.hot) {
      // Enable Webpack hot module replacement for reducers
      module.hot.accept("./reducers", () => {
        // eslint-disable-next-line global-require
        const nextReducers = require("./reducers").default;
        store.replaceReducer(nextReducers);
      });
    }

    return store;
  } catch (error) {
    console.error("Failed to configure store:", error);
    throw error;
  }
}

module.exports = configureStore;
